<template>
  <panel :title="detailsProduct" :onClick="onSelect" :withBody="isDisplayDetails" :withFooter="isDisplayDetails" :to="to">
    <loader :loading="loading"/>

    <div slot="header-right">
      <span v-if="isDisplayList" :data-label="getLastSyncMessage(product.date)" class="badge hint hint--left" :class="productStatus">{{ `${$tc('variations.count.label', product.variations.length, { count: product.variations.length })}` }}</span>
      <button v-if="canSynchronize()" class="btn" @click="syncProduct" title="Sincronizar produto"><i class="icon-sync icon-loop2"></i></button>
    </div>

    <div class="l-row">
      <div class="variation l-col-1@md">
        <img v-if="image" :src="image">
        <i class="icon icon-image2 no-photo" v-else></i>
      </div>

      <blockquote class="l-col-5@md">
        <div class="l-row">
          <div class="l-col-5@md">
            <div class="margin">
              <strong>{{ $t('brand.label') }}</strong>
              {{ product.brand | attribute }}
            </div>
          </div>
          <div class="l-col-7@md">
            <div class="margin">
              <strong>{{ $t('status.label') }}</strong>
              <span class="badge status hint hint--top" :data-label="getLastSyncMessage(product.date)" :class="productStatus">{{ $t(`${productStatus}.label`) }}</span>
            </div>
          </div>
          <div class="l-col-5@md">
            <div class="margin">
              <strong>{{ $t('createdAt.label') }}</strong>
              {{ product.createdAt | moment('DD/MM/YYYY HH:mm') | attribute }}
            </div>
          </div>
          <div class="l-col-7@md">
            <div class="margin">
              <strong>{{ $t('productGroupedId.label') }}</strong>
              {{ product.productId | attribute }}
            </div>
          </div>
          <div class="l-col-5@md">
            <div class="margin">
              <strong>{{ $t('manufacturerReference.label') }}</strong>
              {{ manufacturerReference | attribute }}
            </div>
          </div>
        </div>
      </blockquote>

      <div class="l-col-3@md">
        <div class="l-row">
          <div class="l-col-8@md">
            <div class="margin">
              <strong>{{ product.variations.length === 1 ? 'Variação' : 'Variações' }}</strong>

              <span v-if="product.variations.length === 1">{{ product.variations[0].sku }}</span>
              <span v-else class="link" @click="showVariationModalFlag = true">Ver todas</span>

              <variation-modal v-model="showVariationModalFlag" :product="product"></variation-modal>
            </div>
          </div>
          <div class="l-col-4@md">
            <div class="margin">
              <strong>{{ $t('stock.label') }}</strong>
              {{ quantity | attribute }}
            </div>
          </div>
        </div>
      </div>

      <blockquote class="l-col-3@md">
        <div class="l-row">
            <span class="oldPrice">De {{ oldPrice | currency }} </span>
        </div>
        <div class="l-row">
            <span class="newPrice">Por {{ price | currency }} </span>
        </div>
      </blockquote>
    </div>

    <div slot="footer" class="marketplaces">
      <img v-for="definitionModule in definitionMarketplacesInstalled" v-bind:class="getImgClass(definitionModule)" :src="definitionModule.icon" :alt="definitionModule.name">
    </div>
  </panel>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import Panel from '../../../template/Panel'
  import Loader from '@/components/template/Loader'
  import notifier from '@/notifier'
  import VariationModal from '@/components/ProductProvide/List/VariationModal'

  export default {
    data: () => ({
      type: null,
      identifier: null,
      loading: false,
      quantity: 0,
      oldPrice: 0,
      showVariationModalFlag: false
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      image: {
        type: String,
        required: true
      },
      to: {
        type: Object,
        required: false
      }
    },
    mounted () {
      const [, type, identifier] = this.$route.path.split('/')
      this.type = type
      this.identifier = identifier

      this.product.variations.map(variation => {
        this.quantity += variation.quantity
      })
    },
    methods: {
      ...mapActions('itemsSelected', [
        'add',
        'remove',
        'clear'
      ]),
      ...mapActions('products', [
        'fetchItem'
      ]),
      getImgClass (definitionModule) {
        return {
          notsent: !this.product.variations.find(
            variation => variation.marketplaces.find(marketplace => marketplace.indexOf(definitionModule.identifier) !== -1)
          )
        }
      },
      canSynchronize () {
        if (this.to.path !== undefined && this.to.path.includes('tool/api')) {
          return false
        }
        return true
      },
      onSelect (selected) {
        this.$children[0].selected = selected
        if (selected) {
          this.add(this.product)
        } else {
          this.remove(this.product)
        }
      },
      async syncProduct () {
        this.loading = true

        try {
          await this.fetchItem({
            type: this.type,
            identifier: this.identifier,
            productId: this.product.productId
          })

          notifier.success('Produto sincronizado com sucesso!', 'Sincronizado')
        } catch (err) {
          notifier.error('Falha ao sincronizar o produto com a fonte de dados.', 'Não sincronizado')
        }

        this.loading = false
      },
      getLastSyncMessage () {
        const hasNotSynchronized = (this.product.variations.filter(variation => variation.status === 'not_synchronized')).length
        if (this.productStatus === 'synchronized') {
          return this.$tc(`synchronized.message.label`)
        }
        if (this.productStatus === 'failed_sync') {
          return this.$tc(`failed_sync.message.label`)
        }
        if (this.productStatus === 'partially_synchronized') {
          return this.$tc(`partially_synchronized.message.label`, hasNotSynchronized, { quantity: hasNotSynchronized })
        }
        if (this.productStatus === 'waiting') {
          return this.$tc(`waiting.label`)
        }
      }
    },
    async created () {
      this.clear()
    },
    computed: {
      ...mapGetters('module', [
        'definitionMarketplacesInstalled'
      ]),
      isDisplayList () {
        return this.listInitial === 'displayList'
      },
      isDisplayDetails () {
        return this.listInitial === 'displayDetails'
      },
      listInitial () {
        return this.$parent.$parent.listInitial
      },
      detailsProduct () {
        let title = []

        if (this.product.title) {
          title.push(this.product.title.length > 120 ? this.product.title.substring(0, 120).replace('-', '').trim() + '...' : this.product.title)
        }
        if (this.listInitial === 'displayList') {
          if (this.product.brand) {
            title.push(`Marca: ${this.product.brand}`)
          }

          if (this.price) {
            title.push(`Preço: R$${this.price}`)
          }

          title.push(`Estoque: ${this.quantity}`)
        }

        return title.join(' | ')
      },
      productStatus () {
        const totalVariations = this.product.variations.length
        const hasWaiting = (this.product.variations.filter(variation => variation.status === 'waiting')).length
        if (hasWaiting) {
          return 'waiting'
        }

        const hasNotSynchronized = (this.product.variations.filter(variation => variation.status === 'not_synchronized')).length
        if (hasNotSynchronized === totalVariations) {
          return 'failed_sync'
        }

        if (hasNotSynchronized > 0 && hasWaiting === 0) {
          return 'partially_synchronized'
        }
        return 'synchronized'
      },
      price () {
        let highestPrice = 0
        let oldPrice = this.oldPrice

        this.product.variations.map(variations => {
          if (variations.currentPrice > highestPrice) {
            highestPrice = variations.currentPrice
            oldPrice = variations.previousPrice
          }
        })
        this.oldPrice = oldPrice
        return highestPrice
      },
      manufacturerReference () {
        const variation = this.product.variations.find(variation => variation.manufacturerReference)
        return variation ? variation.manufacturerReference : null
      }
    },
    components: {
      Panel,
      Loader,
      VariationModal
    }
  }
</script>

<style lang="sass" scoped>
  .variation
    text-align: center
    margin-bottom: 16px

    img
      max-width: 70px

    &::after
      content: ''
      height: 100%
      display: inline-block
      vertical-align: middle

    span
      display: block
      font-size: 11px
      margin-top: 5px

  .marketplaces
    img
      max-height: 20px
      margin-right: 15px

  .notsent
    filter: grayscale(100%)

  .no-photo
    font-size: 70px
    color: #a9a9a9
    margin-top: 10px

  strong
    display: block
    margin-bottom: 5px

  .margin
    margin: 10px 0 15px 10px

  .oldPrice
    color: #9a9a9a
    font-size: 13px
    margin: 10px 0 0 15px

  .newPrice
    font-size: 22px
    margin: 0 0 0 15px

  .status
    width: 55%
    text-align: center
    font-size: 12px
    padding: 4px 8px
    line-height: 1
    vertical-align: middle
    display: block
    margin-bottom: 10px
</style>



// WEBPACK FOOTER //
// Shared.vue?bc678bee